import Image from 'next/image';
import IconDarkCharcoal from './account_dark_charcoal.svg?url';
import type { SvgImageProps } from '../types';

export const AccountDarkCharcoalImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={IconDarkCharcoal} alt={alt} {...props} />;
